@if (isPopUpVisible()) {
<app-modal [isOpen]="isPopUpVisible()" [modalSize]="'w-full max-w-sm'" [title]="'common.SELECT_LANGUAGE' | translate"
  (close)="hideLangModal()">
  <div class="p-4 max-h-[70vh] overflow-y-auto scrollbar-hide">
    <div class="flex flex-col space-y-3">

      <div class="border-b pb-3 border-[var(--primary-color)] cursor-pointer" (click)="setLang('en')">
        <p [ngClass]="this.currentLang()==='en'?'text-[var(--primary-color)]':'text-black'"
          class="font-semibold w-fit" >English</p>
      </div>

      <div class="border-b pb-3 border-[var(--primary-color)] cursor-pointer" (click)="setLang('ar')">
        <p [ngClass]="this.currentLang()==='ar'?'text-[var(--primary-color)]':'text-black'"
          class="font-semibold w-fit" >العربية</p>
      </div>

    </div>
  </div>

  <div modal-footer class="flex justify-center">
    <button type="button" class="w-24 bg-[var(--primary-color)] text-white py-2 rounded-md hover:bg-[#093d45] cursor-pointer"
      (click)="onSelectLang()">
      {{ 'common.SELECT' | translate }}
    </button>
  </div>

</app-modal>
}